import React from 'react';
import { Size } from '../../../../Enums/Size.enum';
import Modal from '../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';

export interface BaseModalProps {
	isOpen: boolean;
	onClose: () => void;
	contentScroll?: boolean;
	size?: Size;
	contentStyle?: React.CSSProperties;
	footer?: React.ReactNode;
	headerEnabled?: boolean;
	hideClose?: boolean;
	modalStyle?: React.CSSProperties;
}

interface Props extends BaseModalProps {
	children: React.ReactElement;
	title: string;
}

const BaseModal: React.FC<Props> = ({
	isOpen,
	onClose,
	title,
	contentScroll = true,
	size,
	children,
	contentStyle,
	footer,
	headerEnabled = true,
	hideClose = false,
	modalStyle,
}) => {
	const { isCase } = useTreatmentContext();

	if (!isOpen) {
		return <></>;
	}

	return (
		<Modal
			opened={isOpen}
			onClose={onClose}
			wrapChat={isCase}
			size={size}
			style={modalStyle}>
			{headerEnabled && (
				<Modal.Header firstUpper title={title} hideClose={hideClose} />
			)}
			<Modal.Content contentScroll={contentScroll} contentStyle={contentStyle}>
				{children}
			</Modal.Content>
			{footer && <Modal.Footer>{footer}</Modal.Footer>}
		</Modal>
	);
};

export default BaseModal;
